(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (!url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'most-relevant');
    window.location.replace(url.toString());
  }

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mesafeli-satis-sozlesmesi"] && !Shopify.designMode) return;
  try {
    
(function() {
  var checkbox = document.getElementById('mss-checkbox');
  var errorEl = document.getElementById('mss-error');
  if (!checkbox) return;

  function getCheckoutButtons() {
    return Array.from(document.querySelectorAll(
      '[name="checkout"], button[type="submit"].cart__checkout-button, input[name="checkout"]'
    ));
  }

  function setCheckoutState(enabled) {
    getCheckoutButtons().forEach(function(btn) {
      btn.disabled = !enabled;
      btn.style.opacity = enabled ? '' : '0.4';
      btn.style.cursor = enabled ? '' : 'not-allowed';
    });
    if (errorEl) errorEl.hidden = enabled;
  }

  setCheckoutState(false);

  checkbox.addEventListener('change', function() {
    setCheckoutState(checkbox.checked);
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[name="checkout"], .cart__checkout-button, input[name="checkout"]');
    if (btn && !checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (errorEl) errorEl.hidden = false;
      checkbox.focus();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
